import RichText from './PageBuilder/RichText';

export default RichText;
